// extracted by mini-css-extract-plugin
export default {"fields":"A4KDPV","time":"F6H03q","mobile":"fwzis2"};